import cloneDeep from 'lodash.clonedeep';
import { ValueLabelPair } from 'data/types';
import { FilterModel } from './common-grid.types';

// eslint-disable-next-line import/prefer-default-export
export function adaptToServerValueFilterModel(
  filterModel:FilterModel,
  field:string,
  valueLabelPairList: ValueLabelPair[],
): FilterModel {
  const newFilterModel: FilterModel = cloneDeep(filterModel);
  Object.entries(filterModel).forEach(([key, item]) => {
    if (key === field) {
      // look up all timezone containing the filter, add to filter.
      newFilterModel[field].values = [];
      filterModel[field].values.forEach((value:string) => {
        // Every pair the label matches, not just the first: a label can stand for more
        // than one server value (several Xcipio statuses share one decision state), and
        // sending only the first would silently drop the rows behind the others.
        valueLabelPairList
          .filter((aValueLabel: ValueLabelPair) => (aValueLabel.label === value))
          .forEach((aValueLabel: ValueLabelPair) => {
            newFilterModel[field].values.push(aValueLabel.value);
          });
      });
    } else {
      newFilterModel[key] = item;
    }
  });

  return newFilterModel;
}
